import { supabase } from './supabaseClient';
import type { Pago, MetodoPago } from '../types';
import { notifyPaymentConfirmed, notifyAvisoApproved } from './notificationsService';
import { Logger } from '../utils/logger';

// --- Payments ---

export const getPagos = async (): Promise<Pago[]> => {
    try {
        const { data, error } = await supabase
            .from('pagos')
            .select(`
        *,
        plan:planes(*)
      `)
            .order('fecha_pago', { ascending: false });

        if (error) {
            Logger.error('Error fetching pagos', error);
            return [];
        }

        return data || [];
    } catch (error) {
        Logger.error('Error in getPagos', error);
        return [];
    }
};

export const registrarPagoAviso = async (id_aviso: number, datos_pago: any, id_plan?: number, id_usuario?: number, monto?: number): Promise<boolean> => {
    try {
        Logger.debug('Registrando pago para aviso', { id_aviso });

        // 1. Update aviso status to aprobado and set paid flag
        const { error: avisoError } = await supabase
            .from('avisos')
            .update({
                pagado: true,
                estado: 'aprobado', // Auto-approve upon payment
                fecha_creacion: new Date().toISOString() // Refresh creation date
            })
            .eq('id_aviso', id_aviso);

        if (avisoError) {
            Logger.error('Error updating aviso paid status', avisoError);
            return false;
        }

        // 2. Register payment record if plan info is provided
        if (id_plan && id_usuario && monto) {
            const { error: pagoError } = await supabase
                .from('pagos')
                .insert({
                    id_usuario,
                    id_plan,
                    monto,
                    estado: 'completado',
                    metodo_pago: 'mercadopago', // Default or from datos_pago
                    fecha_pago: new Date().toISOString()
                });

            if (pagoError) {
                Logger.error('Error creating payment record', pagoError);
                // Continue despite payment record error, as the ad is already active
            } else {
                // Notify User about Payment
                await notifyPaymentConfirmed(id_usuario, 0, monto, `Pago Aviso #${id_aviso}`);

                // Notify User about Approval (since it auto-approves)
                // Need title... fetch it? Or just say "Aviso"
                // Fetching title for better UX
                const { data: aviso } = await supabase.from('avisos').select('titulo').eq('id_aviso', id_aviso).single();
                if (aviso) {
                    await notifyAvisoApproved(id_usuario, id_aviso, aviso.titulo);
                }
            }
        }

        return true;
    } catch (error) {
        Logger.error('Exception in registrarPagoAviso', error);
        return false;
    }
};
